import { EmployersNumber } from "../types";

export const employersNumberLabelMap: Record<EmployersNumber, string> = {
  None: "None",
  "1To10": "1-10",
  "11To50": "11-50",
  "51To250": "51-250",
  Over250: "Over 250"
};
